import React, { useState, useEffect } from "react";
import { useHistory } from "react-router-dom";
import useNavigation from "../../../utils/useNavigation";
import Modal from "../../../components/controls/modal/Modal";
import Tabs from "../../../components/controls/tabs/Tabs";
import OverviewHeader from "../../../components/overviewHeader/OverviewHeader";
import InputUnderline from "../../../components/controls/input/InputUnderline";
import Details from "../../details/details";
import AllocatedResources from "../../allocatedResources";
import Portfolios from "../../portfolio/portfolios";
import Programs from "../../program/programs";
import Projects from "../../project/projects";
import Communication from "../../communication";
import Contracts from "../contracts";
import { countries } from "../../../helpers/utils";
import service from "../../../store/services/clients.service";
import deletionRequestService from "../../../store/services/deletionRequest.service";
import Input from "../../../components/controls/input/customInput/CustomInput";
import DropDown from "../../../components/controls/dropdown/DropdownFluent";
import { Avatar, Tooltip } from "@fluentui/react-components";
import {
  dateOnlyFormatted,
  weeksBetweenDates,
} from "../../../utils/systemSettings";
import { CalendarIcon, UploadCloudIcon } from "../../../modules/default-svg";
import { URL_UPDATE_CLIENT_LOGO } from "../../../store/services/URL";
import { useDispatch } from "react-redux";
import { generalActions } from "../../../store/actions";
import ContactsSelect from "../../../components/contactsSelect/ContactsSelect";
import DeleteRequest from "../../../components/DeleteRequest/DeleteRequest";
import RichTextEditor from "../../../components/richTextEditor/RichTextEditor";
import EntityFileUpload from "../../../components/controls/fileUpload/EntityFileUpload";
import { ListChevronsDownUp, ListChevronsUpDown, Trash2 } from "lucide-react";
import styles from "../clients/Clients.module.css";
import { ParentType } from "../../resourcesReport/constants";
import ResourcesReport from "../../resourcesReport/ResourcesReport";

const ClientOverview = (props) => {
  const {
    clientID,
    getClientDetails,
    updateClientRequest,
    clientData,
    loading,
    deleteRequest,
    clientLoading,
  } = props;
  const settings = JSON.parse(localStorage.getItem("settings"));
  const [data, setData] = useState({});
  const [name, setName] = useState("");
  const [managerId, setManagerId] = useState("");
  const [refId, setRefId] = useState("");
  const [address, setAddress] = useState("");
  const [city, setCity] = useState("");
  const [stateProvince, setStateProvince] = useState("");
  const [postalCode, setPostalCode] = useState("");
  const [country, setCountry] = useState("");
  const [industry, setIndustry] = useState("");
  const [status, setStatus] = useState("");
  const [notes, setNotes] = useState("");
  const [mgntTeam, setMgntTeam] = useState("");
  const [mgntTeamIds, setMgntTeamIds] = useState("");
  const [coreTeam, setCoreTeam] = useState("");
  const [coreTeamIds, setCoreTeamIds] = useState("");
  const [businessUnit, setBusinessUnit] = useState("");
  const [contractStartDate, setContractStartDate] = useState("");
  const [contractEndDate, setContractEndDate] = useState("");
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [focal, setFocal] = useState("");
  // const [resources, setResources] = useState([]);
  const [isEdit, setIsEdit] = useState(false);
  const [deleteModal, setDeleteModal] = useState(false);
  const [attachments, setAttachments] = useState([]);

  const { updateTab, getSelectedTab } = useNavigation();

  const savedTab = getSelectedTab("Clients", clientID);
  const [selectedNavItem, setSelectedNavItem] = useState(savedTab || "details");
  const [creator, setCreator] = useState({});
  const [manager, setManager] = useState({});
  const [headerTitle, setHeaderTitle] = useState({});
  const history = useHistory();

  // Handle tab change - update both local state and Redux state
  const handleTabChange = (newTab) => {
    setSelectedNavItem(newTab);
    updateTab(newTab);
  };

  // Update tab state when navigation changes (e.g., back/forward navigation)
  useEffect(() => {
    const currentSavedTab = getSelectedTab("Clients", clientID);
    if (currentSavedTab && currentSavedTab !== selectedNavItem) {
      setSelectedNavItem(currentSavedTab);
    }
  }, [getSelectedTab, clientID, selectedNavItem]);

  const [setting] = useState(settings);
  const [avatarImage, setAvatarImage] = useState(null);
  const [integratorLogo, setIntegratorLogo] = useState(null);
  const [integratorLogoUrl, setIntegratorLogoUrl] = useState(null);
  const [integratorLogoLoading, setIntegratorLogoLoading] = useState(false);
  const [formErrors, setFormErrors] = useState({
    name: "",
    managerId: "",
    endDate: "",
  });
  const [isLoading, setIsLoading] = useState(false);
  const [isPendingDelete, setIsPendingDelete] = useState({});
  const [isDeleteLoading, setIsDeleteLoading] = useState(false);
  const [deleteRequestModal, setDeleteRequestModal] = useState(false);
  const [deleteRequestData, setDeleteRequestData] = useState({});
  const [isHeaderCollapsed, setIsHeaderCollapsed] = useState(localStorage.getItem("isOverviewHeaderCollapsed") === "true");

  const dispatch = useDispatch();

  const handleHeaderSectionState = () => {
    setIsHeaderCollapsed(!isHeaderCollapsed);
    localStorage.setItem("isOverviewHeaderCollapsed" ,!isHeaderCollapsed);
  }

  const overviewHeaderFields = [
    { ...creator,
      label: "Created By",
      isResource: true,
    },
    {
      ...manager,
      label: "Client Manager",
      name: manager?.name || manager?.email || manager?.phone,
      title: "Manager",
      image: ""
    },
    {
      label: "Start / End date",
      name: contractStartDate || contractEndDate
        ? `${contractStartDate ? dateOnlyFormatted(setting, contractStartDate) : "-"} to ${contractEndDate ? dateOnlyFormatted(setting, contractEndDate) : "-"}`
        : "-",
      secondary: contractStartDate && contractEndDate
        ? weeksBetweenDates(contractStartDate, contractEndDate)
        : null,
    },
  ];

  const parentData = { id: clientID, type: 0 };

  const renderSelectedComponent = () => {
    switch (selectedNavItem) {
      case "details":
        return <Details data={clientData} type="Client" isHeaderCollapsed={isHeaderCollapsed} />;
      case "portfolios":
        return (
          <Portfolios
            clientID={clientID}
            defaultClient={clientData}
            overviewType="Client"
          />
        );
      case "programs":
        return (
          <Programs
            clientID={clientID}
            defaultClient={clientData}
            overviewType="Client"
          />
        );
      case "projects":
        return (
          <Projects
            clientID={clientID}
            defaultClient={clientData}
            overviewType="Client"
          />
        );
      case "allocatedResources":
        return <ResourcesReport 
                  parentType={ParentType.CLIENT} 
                  parentId={clientID}/>;
      case "communication":
        return (
          <Communication
            clientID={clientID}
            defaultClient={clientData}
            overviewType="Client"
          />
        );
      // case "contracts":
      //   return <Contracts />;
      default:
        return <Details data={clientData} type="Client" isHeaderCollapsed={isHeaderCollapsed} />;
    }
  };

  // const searchHandler = (value) => {
  //   if (value === "") {
  //     setResources([]);
  //     return;
  //   }
  //   // if (value) {
  //   userService
  //     .searchUserDataRequest(value)
  //     .then((res) => {
  //       const transformedArray = res.map((obj) => ({
  //         label: obj.name,
  //         value: obj.id,
  //       }));
  //       setResources(transformedArray);
  //     })
  //     .catch(() => {
  //       setResources([]);
  //     });
  //   // } else {
  //   //     setResources([]);
  //   // }
  // };

  const handleEndDate = (e) => {
    if (new Date(e) <= new Date(contractStartDate)) {
      setFormErrors((prevErrors) => ({
        ...prevErrors,
        endDate: "End Date should be after Start Date",
      }));
    } else {
      setFormErrors({});
      setEndDate(e);
    }
  };

  const handleUpdateImageChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onload = () => {
        setAvatarImage(reader.result); // Set the uploaded image as a data URL
      };
      reader.readAsDataURL(file);
      const payload = new FormData();
      payload.append("file", file);
      const token = localStorage.getItem("accessToken");
      let headers = {};
      if (token) {
        headers = {
          Authorization: `Bearer ${token.replace(/"/g, "")}`,
        };
      }
      const options = {
        method: "PUT",
        headers: headers,
        body: payload,
      };
      return fetch(`${URL_UPDATE_CLIENT_LOGO}${clientID}/Logo`, options)
        .then(async (response) => {
          if (response.status === 400) {
            dispatch(
              generalActions.showToast({
                title: "File type not supported",
                type: "error",
              })
            );
          }
          if (response.status === 200) {
            dispatch(
              generalActions.showToast({
                title: "Logo updated successfully",
                type: "success",
              })
            );
          }
        })
        .then()
        .catch((error) => {
          console.error("Error:", error);
        });
    }
  };

  const handleUpdateIntegratorLogoChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setIntegratorLogoLoading(true);
      const reader = new FileReader();
      reader.onload = () => {
        setIntegratorLogoUrl(reader.result);
      };
      reader.readAsDataURL(file);
      
      const payload = new FormData();
      payload.append("File", file);
      payload.append("IsDelete", false);
      
      const token = localStorage.getItem("accessToken");
      let headers = {};
      if (token) {
        headers = {
          Authorization: `Bearer ${token.replace(/"/g, "")}`,
        };
      }
      const options = {
        method: "PUT",
        headers: headers,
        body: payload,
      };
      return fetch(`${URL_UPDATE_CLIENT_LOGO}${clientID}/integrator-logo`, options)
        .then(async (response) => {
          if (response.status === 400) {
            dispatch(
              generalActions.showToast({
                title: "File type not supported",
                type: "error",
              })
            );
          }
          if (response.status === 200) {
            dispatch(
              generalActions.showToast({
                title: "Integrator logo updated successfully",
                type: "success",
              })
            );
          }
        })
        .catch((error) => {
          console.error("Error:", error);
          dispatch(
            generalActions.showToast({
              title: "Failed to update integrator logo",
              type: "error",
            })
          );
        })
        .finally(() => {
          setIntegratorLogoLoading(false);
        });
    }
  };

  const handleDeleteIntegratorLogo = () => {
    setIntegratorLogoLoading(true);
    const payload = new FormData();
    payload.append("IsDelete", true);
    
    const token = localStorage.getItem("accessToken");
    let headers = {};
    if (token) {
      headers = {
        Authorization: `Bearer ${token.replace(/"/g, "")}`,
      };
    }
    const options = {
      method: "PUT",
      headers: headers,
      body: payload,
    };
    return fetch(`${URL_UPDATE_CLIENT_LOGO}${clientID}/integrator-logo`, options)
      .then(async (response) => {
        if (response.status === 200) {
          setIntegratorLogoUrl(null);
          dispatch(
            generalActions.showToast({
              title: "Integrator logo deleted successfully",
              type: "success",
            })
          );
        }
      })
      .catch((error) => {
        console.error("Error:", error);
        dispatch(
          generalActions.showToast({
            title: "Failed to delete integrator logo",
            type: "error",
          })
        );
      })
      .finally(() => {
        setIntegratorLogoLoading(false);
      });
  };

  const formBody = () => {
    return (
      <>
        <div className="d-flex align-items-center mb-3">
          {avatarImage ? (
            <div className="clientLogoContainer relative flex flex-col items-center justify-center max-w-32 h-14 overflow-hidden pr-2">
              <img
                src={avatarImage}
                alt="Client Logo"
                className="max-w-full max-h-full object-contain"
              />

              <div className="upload-icon absolute bottom-1 right-1 bg-white rounded-full p-1 shadow-md cursor-pointer">
                <label htmlFor="avatarUpload" className="cursor-pointer">
                  <UploadCloudIcon />
                </label>
                <input
                  id="avatarUpload"
                  type="file"
                  accept="image/*"
                  style={{ display: "none" }}
                  onChange={handleUpdateImageChange}
                />
              </div>
            </div>
          ) : (
            <Avatar
              className="me-20 ModalAvatarBadge"
              size={64}
              color="neutral"
              name={name}
              shape="square"
              image={""}
              badge={{
                icon: (
                  <div className="upload-icon cursor-pointer">
                    <label htmlFor="avatarUpload">
                      <UploadCloudIcon />
                    </label>
                    <input
                      id="avatarUpload"
                      type="file"
                      accept="image/*"
                      style={{ display: "none" }}
                      onChange={handleUpdateImageChange}
                    />
                  </div>
                ),
              }}
            />
          )}

          <InputUnderline
            inputUnderlinewd="w-100"
            isRequired
            placeholder="Add client name"
            value={name}
            handleChange={setName}
            error={formErrors.name}
            loading={isLoading}
          />
        </div>

        <div className={`${styles.integratorLogoSection} ${integratorLogoLoading ? styles.loading : ''}`}>
          {integratorLogoLoading && (
            <div className={styles.loadingOverlay}>
              <div className={styles.loadingSpinner}></div>
            </div>
          )}
          
          <label className={styles.integratorLogoLabel}>Integrator Logo</label>
          <div className={styles.integratorLogoContainer}>
            {integratorLogoUrl ? (
              <>
                <div className={styles.logoImageWrapper}>
                  <label htmlFor="integratorLogoUploadEdit" className="w-100 h-100 d-flex align-items-center justify-content-center cursor-pointer m-0">
                    <img
                      src={integratorLogoUrl}
                      alt="Integrator Logo"
                    />
                  </label>
                  <input
                    id="integratorLogoUploadEdit"
                    type="file"
                    accept="image/*"
                    style={{ display: "none" }}
                    onChange={handleUpdateIntegratorLogoChange}
                    disabled={integratorLogoLoading}
                  />
                </div>
                <div className={styles.logoActions}>
                  <button
                    type="button"
                    className={styles.deleteButton}
                    onClick={handleDeleteIntegratorLogo}
                    disabled={integratorLogoLoading}
                    title="Delete integrator logo"
                  >
                    <Trash2 />
                  </button>
                </div>
              </>
            ) : (
              <div className={`${styles.uploadPrompt} ${isLoading ? styles.disabled : ''}`}>
                <label htmlFor="integratorLogoUpload" className="cursor-pointer d-flex align-items-center gap-2 m-0">
                  <UploadCloudIcon />
                  <span className={styles.uploadPromptText}>Upload</span>
                </label>
                <input
                  id="integratorLogoUpload"
                  type="file"
                  accept="image/*"
                  style={{ display: "none" }}
                  onChange={handleUpdateIntegratorLogoChange}
                  disabled={isLoading}
                />
              </div>
            )}
          </div>
        </div>

        <div className="ModalAvatarGroup">
          <div className="row align-items-end gx-3">
            <div className="col-12">
              <label class="Input_label">Client Manager</label>
              <ContactsSelect
                parentType="Clients"
                parentId={clientID}
                isMultiSelect={false}
                confirmHandler={setManagerId}
                existingSelectedContacts={manager ? [...[], manager] : []}
                isNewParent={false}
              />
            </div>
          </div>
        </div>
        <div className="ModalAvatarGroup">
          <div className="row align-items-end gx-3">
            <div className="col-12">
              <label class="Input_label">Management Team</label>
              <ContactsSelect
                parentType="Clients"
                parentId={clientID}
                confirmHandler={setMgntTeamIds}
                existingSelectedContacts={mgntTeam}
                isNewParent={false}
              />
            </div>
          </div>
        </div>
        <div className="ModalAvatarGroup">
          <div className="row align-items-end gx-3">
            <div className="col-12">
              <label class="Input_label">Core Team</label>
              <ContactsSelect
                parentType="Clients"
                parentId={clientID}
                confirmHandler={setCoreTeamIds}
                existingSelectedContacts={coreTeam}
                isNewParent={false}
              />
            </div>
          </div>
        </div>
        <div className="row align-items-center gx-3 mb-3">
          <div className="col-4">
            <Input
              icon={false}
              placeholder="Enter Account ID"
              value={refId}
              type="text"
              handleChange={setRefId}
              label="Account ID"
              loading={isLoading}
            />
          </div>
          <div className="col-4">
            <Input
              icon={false}
              placeholder="Enter industry"
              value={industry}
              type="text"
              handleChange={setIndustry}
              label="Industry"
              loading={isLoading}
            />
          </div>
          <div className="col-4">
            <Input
              icon={false}
              placeholder="Enter business unit"
              value={businessUnit}
              type="text"
              handleChange={setBusinessUnit}
              label="Business Unit"
              loading={isLoading}
            />
          </div>
        </div>
        <div className="row align-items-center gx-3 mb-3">
          <div className="col-4">
            <Input
              icon={<CalendarIcon />}
              value={startDate}
              maxDate={endDate}
              type="date"
              handleChange={setStartDate}
              label="Contract Start Date"
              loading={isLoading}
            />
          </div>
          <div className="col-4">
            <Input
              icon={<CalendarIcon />}
              value={endDate}
              minDate={startDate}
              type="date"
              handleChange={handleEndDate}
              label="Contract End Date"
              errorMessage={formErrors.endDate}
              loading={isLoading}
            />
          </div>
          <div className="col-4">
            <Input
              value={focal}
              placeholder="Enter focal"
              type="text"
              handleChange={setFocal}
              label="Focal"
              loading={isLoading}
            />
          </div>
        </div>
        <div className="row align-items-center gx-3 mb-3">
          <div className="col-4">
            <DropDown
              label="Country"
              placeholder="country"
              options={countries}
              defaultVal={country}
              onChange={setCountry}
              loading={isLoading}
            />
            {/* <Searchable label="Program" SelectText="program" options={programs} defaultVal={program} onChange={setProgram} /> */}
          </div>
          <div className="col-4">
            <Input
              icon={false}
              placeholder="Enter city"
              value={city}
              type="text"
              handleChange={setCity}
              label="City"
              loading={isLoading}
            />
          </div>
          <div className="col-4">
            <Input
              icon={false}
              placeholder="Enter state & province"
              value={stateProvince}
              type="text"
              handleChange={setStateProvince}
              label="State & Province"
              loading={isLoading}
            />
          </div>
        </div>
        <div className="row align-items-center gx-3 mb-3">
          <div className="col-4">
            <Input
              icon={false}
              placeholder="Enter postal code"
              value={postalCode}
              type="text"
              handleChange={setPostalCode}
              label="Postal Code"
              loading={isLoading}
            />
          </div>
          <div className="col-4">
            <Input
              icon={false}
              placeholder="Enter status"
              value={status}
              type="text"
              handleChange={setStatus}
              label="Enter Status"
              loading={isLoading}
            />
          </div>
        </div>
        <div className="mb-3">
          <RichTextEditor
            label="Additional Address"
            content={address}
            onChange={setAddress}
            loading={isLoading}
            limit={255}
          />
        </div>
        <div className="mb-3">
          <RichTextEditor
            label="Notes"
            content={notes}
            onChange={setNotes}
            loading={isLoading}
          />
        </div>
        <EntityFileUpload
          entityId={clientID}
          entityType="Client"
          attachments={attachments}
          onAttachmentsChange={() => {
            service.fetchSingleClientDataRequest(clientID)
            .then((clientData) => {
              setAttachments(clientData.attachments);
            })
            .catch((error) => {
              console.error("Error fetching client data:", error);
            });
          }}
          disabled={isLoading || !clientID}
        />
      </>
    );
  };

  const showDeleteModal = () => {
    setDeleteModal(true);
  };

  const showEditModal = () => {
    setIsEdit(true);
  };

  const handleSave = () => {
    const errors = {};
    if (!name) errors["name"] = `Name Field is Required`;
    setFormErrors(errors);
    if (Object.keys(errors).length) {
      return;
    }
    const payload = {
      name,
      managerId: managerId,
      refId,
      address: address,
      mgntTeam: mgntTeamIds,
      coreTeam: coreTeamIds,
      businessUnit: businessUnit,
      focal: focal,
      city,
      stateProvince,
      postalCode: parseInt(postalCode),
      country,
      industry,
      status,
      notes,
      contractStartDate: startDate,
      contractEndDate: endDate,
    };
    updateClientRequest({ id: clientData.id, type: "overview", payload });
    // setIsEdit(false);
    // console.log(isDisable)
    // setIsDisable(false);
  };

  useEffect(() => {
    if (!loading) {
      setIsEdit(false);
    }
  }, [loading]);

  const handleCancel = () => {
    setFormErrors({});
    setDeleteModal(false);
    setIsEdit(false);
  };

  const handleDelete = () => {
    setIsDeleteLoading(true);
    if (deleteRequest) {
      deletionRequestService
        .confirmDeletionRequest(deleteRequest.requestId)
        .then((response) => {
          setIsDeleteLoading(false);
          setDeleteModal(false);
          history.push(`/clients`);
        })
        .catch((err) => {
          dispatch(
            generalActions.showToast({
              title: "Something went wrong. Please try again later.",
              type: "error",
            })
          );
          setIsDeleteLoading(true);
          setDeleteModal(false);
        });
    } else {
      service
        .deleteClient(data.id)
        .then((response) => {
          setIsDeleteLoading(false);
          setDeleteModal(false);
          if (response && !response.IsDeletionAllowed) {
            setDeleteRequestData(response);
            setDeleteRequestModal(true);
          } else {
            history.push(`/clients`);
          }
        })
        .catch((err) => {
          dispatch(
            generalActions.showToast({
              title: "Something went wrong. Please try again later.",
              type: "error",
            })
          );
          setIsDeleteLoading(true);
          setDeleteModal(false);
        });
    }
  };

  useEffect(() => {
    if (clientData && clientData.hasOwnProperty("name")) {
      setCreator(clientData?.creator);
      setManager(clientData?.manager);
      setManagerId(clientData?.manager?.id);
      setMgntTeam(clientData.mgntTeam);
      setMgntTeamIds(
        clientData.mgntTeam?.length > 0
          ? clientData.mgntTeam.map((contact) => contact.id).join(",")
          : ""
      );
      setCoreTeam(clientData.coreTeam);
      setCoreTeamIds(
        clientData.coreTeam?.length > 0
          ? clientData.coreTeam.map((contact) => contact.id).join(",")
          : ""
      );
      setContractStartDate(clientData?.contractStartDate);
      setContractEndDate(clientData?.contractEndDate);
      setHeaderTitle(clientData);
      setIsPendingDelete(clientData?.isPendingDelete);
      setData(clientData);
    }
  }, [clientData]);

  const fetchClientData = async () => {
    setIsLoading(true);
    service
      .fetchSingleClientDataRequest(data.id)
      .then((clientData) => {
        setName(clientData.name);
        setRefId(clientData.refId);
        setIndustry(clientData.industry);
        setManager(clientData.manager);
        setManagerId(clientData.manager?.id);
        setMgntTeam(clientData.mgntTeam);
        setMgntTeamIds(
          clientData.mgntTeam?.length > 0
            ? clientData.mgntTeam.map((contact) => contact.id).join(",")
            : ""
        );
        setCoreTeam(clientData.coreTeam);
        setCoreTeamIds(
          clientData.coreTeam?.length > 0
            ? clientData.coreTeam.map((contact) => contact.id).join(",")
            : ""
        );
        setBusinessUnit(clientData.businessUnit);
        setStartDate(clientData.contractStartDate);
        setEndDate(clientData.contractEndDate);
        setFocal(clientData.focal);
        setCountry(clientData.country);
        setCity(clientData.city);
        setStateProvince(clientData.stateProvince);
        setPostalCode(clientData.postalCode);
        setStatus(clientData.status);
        setAddress(clientData.address);
        setNotes(clientData.notes);
        setAvatarImage(clientData.logoUrl);
        setIntegratorLogoUrl(clientData.integratorLogoUrl);
        setAttachments(clientData.attachments || []);
        // setTimeout(() => {
        setIsLoading(false);
        // }, 3000);
      })
      .catch((error) => console.error("Error fetching user data:", error));
  };

  useEffect(() => {
    if (isEdit) {
      fetchClientData();
    }
  }, [isEdit]);

  useEffect(() => {
    getClientDetails({ id: clientID });
  }, []);

  useEffect(() => {
    if (name) {
      setFormErrors((prevErrors) => ({
        ...prevErrors,
        name: "",
      }));
    }
    if (managerId) {
      setFormErrors((prevErrors) => ({
        ...prevErrors,
        managerId: "",
      }));
    }
  }, [managerId, name]);

  const handleDeleteRequested = () => {
    getClientDetails({ id: clientID });
  };

  useEffect(() => {
    if (deleteRequest) {
      setDeleteModal(true);
    }
  }, [deleteRequest]);

  return (
    <div className="relative">
      {
        !isHeaderCollapsed && 
        (
        <OverviewHeader
          entityType="client"
          headerTitle={headerTitle}
          headerFields={overviewHeaderFields}
          parentData={parentData}
          showDeleteModal={showDeleteModal}
          showEditModal={showEditModal}
          isShowAction
          loading={clientLoading}
          isPendingDelete={isPendingDelete}
          handleRefresh={() => handleDeleteRequested()}
        />
        )
      }
      <div className={isHeaderCollapsed ? "pt-3": ''}>
        <Tabs
          selectedTab={selectedNavItem}
          setSelectedTab={handleTabChange}
          type="clients"
        />
      </div>
      {deleteModal && (
        <Modal
          title={`Delete Client`}
          body={
            <p className="text-sm-400 subHeading-color">{`Are you sure you want to delete the client?`}</p>
          }
          handleCancel={() => handleCancel()}
          handleSave={() => handleDelete()}
          saveBtnLabel="Delete"
          cancelBtnLabel="Cancel"
          isLoading={isDeleteLoading}
        />
      )}
      {deleteRequestModal && (
        <DeleteRequest
          data={deleteRequestData}
          handleCancel={setDeleteRequestModal}
          handleRefresh={() => handleDeleteRequested()}
        />
      )}
      {isEdit && (
        <Modal
          title={`Edit ${clientData.name}`}
          handleCancel={() => handleCancel()}
          handleSave={() => handleSave()}
          saveBtnLabel="Save"
          cancelBtnLabel="Cancel"
          isLoading={loading}
          size="large"
          body={formBody()}
        />
      )}
      <section
        className="TabsContentSection"
        style={{
          height: `calc(100vh - ${isHeaderCollapsed ?'205':'360'}px)`,
        }}
      >
        <div key={selectedNavItem} className="TabsContentFade">
          {renderSelectedComponent()}
        </div>
      </section>
      {!clientLoading && 
      (
        <div 
        className="absolute top-1 right-2 cursor-pointer opacity-50 hover:opacity-100 hover:text-[#342C82] px-3 py-1 transition-all duration-150 ease-in-out"
          onClick={handleHeaderSectionState}>
          <Tooltip content={isHeaderCollapsed ? "Expand" :"Collapse"} relationship="label" positioning="before">
            {isHeaderCollapsed ? <ListChevronsUpDown size={20}/> : <ListChevronsDownUp size={20} />}
          </Tooltip>
        </div>
      )}
    </div>
  );
};
export default ClientOverview;
